<template lang="html">
  <div
    class="alert alert-warning d-block"
    role="alert">
    <p class="alert-heading mb-0"><strong>{{ __('title_form_errors') }}</strong></p>
    <p class="m-0"><small><i>{{ __('fix_form_try_again') }}</i></small></p>

    <ul class="mt-3">
      <div
        v-for="(error, errorKey) in errors"
        :key="errorKey">
        <li v-if="errorIsString(error)">
          <small>{{ error }}</small>
        </li>

        <template v-else>
          <li
            v-for="(innerError, innerErrorKey) in error"
            :key="innerErrorKey">
            <small>{{ formatInnerError(innerError) }}</small>
          </li>
        </template>
      </div>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'My360Errors',

  props: {
    errors: {
      type: [Array, Object],
      required: false,
      default: () => { return {} }
    }
  },

  methods: {
    errorIsString (error) {
      return typeof error === 'string'
    },

    formatInnerError (error) {
      error = error[0] ? error[0] : error
      if (typeof error === 'object') {
        // var key = Object.keys(error)[0]
        return Object.values(error)[0]
      }
      return error
    }
  }
}
</script>
